import { render, staticRenderFns } from "./Thg.vue?vue&type=template&id=5a8044f4"
import script from "./Thg.vue?vue&type=script&lang=ts"
export * from "./Thg.vue?vue&type=script&lang=ts"
import style1 from "./Thg.vue?vue&type=style&index=1&id=5a8044f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports